var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 28.4746,
    rx: 14.2373,
    fill: "#D2D2D2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9423 9.56522H18.1432L17.2585 8.23217C17.2111 8.16079 17.147 8.10226 17.0717 8.06176C16.9964 8.02127 16.9123 8.00005 16.8269 8H12.6731C12.5877 8.00005 12.5036 8.02127 12.4283 8.06176C12.353 8.10226 12.2889 8.16079 12.2415 8.23217L11.3562 9.56522H9.55769C9.14457 9.56522 8.74836 9.73012 8.45624 10.0237C8.16411 10.3172 8 10.7153 8 11.1304V18.4348C8 18.8499 8.16411 19.248 8.45624 19.5416C8.74836 19.8351 9.14457 20 9.55769 20H19.9423C20.3554 20 20.7516 19.8351 21.0438 19.5416C21.3359 19.248 21.5 18.8499 21.5 18.4348V11.1304C21.5 10.7153 21.3359 10.3172 21.0438 10.0237C20.7516 9.73012 20.3554 9.56522 19.9423 9.56522ZM17.0865 14.5217C17.0865 14.9861 16.9495 15.44 16.6928 15.8261C16.436 16.2122 16.0711 16.5131 15.6442 16.6908C15.2172 16.8685 14.7474 16.915 14.2942 16.8245C13.8409 16.7339 13.4246 16.5103 13.0978 16.1819C12.771 15.8536 12.5485 15.4352 12.4584 14.9798C12.3682 14.5243 12.4145 14.0523 12.5913 13.6233C12.7682 13.1943 13.0676 12.8276 13.4519 12.5696C13.8361 12.3116 14.2879 12.1739 14.75 12.1739C15.3697 12.1739 15.964 12.4213 16.4022 12.8616C16.8404 13.3019 17.0865 13.8991 17.0865 14.5217Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraCircle);
export default __webpack_public_path__ + "static/media/cameraCircle.9bfaf689e628a197ea34145a692a762c.svg";
export { ForwardRef as ReactComponent };